export const initialConfigs = async () => {
  const json = await fetch("/ui/config/v1/init");
  const res = await json.json();
  return res
};
